'use client'
import type { Locale } from './LangContext'
import { LangContext } from './LangContext'

export function LangProvider({ lang, children }: { lang: Locale; children: React.ReactNode }) {
  return <LangContext.Provider value={lang}>{children}</LangContext.Provider>
}
